if (!customElements.get('product-discount-code')) {
  customElements.define(
    'product-discount-code',
    class ProductDiscountCode extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-discount-copy]');
        this.label = this.querySelector('[data-discount-copy-label]');
        this.status = this.querySelector('[data-discount-copy-status]');

        if (!this.button || !this.label) return;

        this.button.addEventListener('click', () => this.copyCode());
      }

      async copyCode() {
        const code = this.dataset.discountCode;
        if (!code) return;

        try {
          await this.writeToClipboard(code);
          this.showCopiedState();
        } catch (error) {
          if (this.status) this.status.textContent = 'Unable to copy discount code.';
        }
      }

      async writeToClipboard(value) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await Promise.race([
              navigator.clipboard.writeText(value),
              new Promise((_, reject) => setTimeout(() => reject(new Error('Clipboard timeout')), 1200)),
            ]);
            return;
          } catch (error) {
            // Some embedded browsers expose Clipboard API but never resolve it.
            // Fall through to the synchronous copy method in that case.
          }
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();

        if (!copied) throw new Error('Copy command failed');
      }

      showCopiedState() {
        clearTimeout(this.resetTimer);
        this.button.classList.add('is-copied');
        this.label.textContent = this.dataset.copiedLabel || 'Copied';
        if (this.status) this.status.textContent = `${this.dataset.discountCode} copied.`;

        this.resetTimer = setTimeout(() => {
          this.button.classList.remove('is-copied');
          this.label.textContent = this.dataset.copyLabel || 'Copy code';
        }, 3000);
      }
    },
  );
}
